if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();

        this.sliderOptions = {
          slidesPerView: '1',
          spaceBetween: 10,
          loop: true,
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
        };
      }

      connectedCallback() {
        const slider = this.querySelector('.swiper');

        // Eine einzige Slide (Set shoppen rendert alle Produkte in EINER Liste):
        // loop klont sie, und schon 6px Mausbewegung beim Klick zählen als Swipe.
        // Swiper wechselt dann auf die Kopie und schluckt den Klick, Kundinnen
        // brauchten teils 5 Versuche (Kathrin 1.11.). Darum ohne Loop und Swipe.
        if (slider && slider.querySelectorAll('.swiper-slide').length <= 1) {
          this.sliderOptions.loop = false;
          this.sliderOptions.allowTouchMove = false;
        }
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
